const SmokingStatus = [
  { name: "Never Smoked", value: "Never Smoked" },
  { name: "Former Smoker", value: "Former Smoker" },
  { name: "Current Smoker", value: "Current Smoker" },
];

export default SmokingStatus;
